import { ForwardedRef, ReactElement, forwardRef } from 'react';

import { ListGroup } from 'react-bootstrap';
import { SelectTypes } from '@/common/Select/types';
import { getClasses } from '@/utils';

const SelectOption = forwardRef(
  ({ static: isStatic, ...props }: SelectTypes.OptionProps, ref: ForwardedRef<HTMLAnchorElement>): ReactElement => (
    <ListGroup.Item
      {...props}
      role="option"
      as="a"
      className={getClasses('Select-Option', isStatic ? 'Select-StaticOption' : undefined, props.className)}
      action
      ref={ref}
    />
  )
);
SelectOption.displayName = 'SelectOption';

export default SelectOption;
